<div class="filter-row" [class.d-none]="hideFilters">
  <div class="filter-row-container">
    <div class="filter-title tw-flex-center">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon button with a vertical three dot icon arrow-button"
      >
        <mat-icon class="dark:tw-text-gray-300">more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let filterItem of filterItems">
          <button
            *ngIf="filterItem.IsVisible"
            mat-menu-item
            (click)="toggleItem(filterItem.Key, this)"
          >
            <i
              class="mdi mdi-check-bold text-navyBlue"
              *ngIf="filterItem.Checked"
            ></i>
            <i
              class="mdi mdi-square-outline text-navyBlue"
              *ngIf="filterItem.Checked == false"
            ></i>
            {{ filterItem.Title | translate }}
          </button>
        </ng-container>
      </mat-menu>

      <label class="filter-title-label">
        {{ "pages.createSmartSmsRequest.filters.title" | translate }}
      </label>
    </div>

    <div class="chip-list">
      <button
        *ngIf="!filtersIsLimited"
        class="arrow-button"
        (click)="moveChipList(-1)"
      >
        <i class="mdi mdi-arrow-right tw-text-white"></i>
      </button>

      <div
        class="chip-list-container tw-py-1"
        #chipList
        [style.overflow-x]="filtersIsLimited ? 'hidden' : 'scroll'"
      >
        <mat-chip-grid [ariaOrientation]="'vertical'">
          <ng-container *ngFor="let filterItem of filterItems">
            <ng-container *ngIf="filterItem.IsVisible">
              <mat-chip-row
                *ngIf="filterItem.Checked == false"
                (click)="toggleItem(filterItem.Key, this)"
              >
                {{ filterItem.Title | translate }}
              </mat-chip-row>
              <mat-chip-row
                color="primary"
                class="mat-chip-selected"
                *ngIf="filterItem.Checked == true"
                (click)="toggleItem(filterItem.Key, this)"
                selected
              >
                {{ filterItem.Title | translate }}
              </mat-chip-row>
            </ng-container>
          </ng-container>
        </mat-chip-grid>
      </div>

      <button
        *ngIf="!filtersIsLimited"
        class="arrow-button"
        (click)="moveChipList(1)"
      >
        <i class="mdi mdi-arrow-left tw-text-white"></i>
      </button>
    </div>
  </div>
</div>
